export default "__VITE_ASSET__DfwwHS9O__"